export default __webpack_public_path__ + "static/1152-99456b2b217d1da855a898c949171042.gif";